import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/ui/DropdownMenu';

import OrganizationDepartmentsIcon from '@assets/icons/organization-departments.svg?react';

import { organizationItems } from './DesktopSidebar.config';
import {
  activeNavItemStyle,
  dropdownContentClass,
} from './DesktopSidebar.styles';
import {
  getNavItemClass,
  SidebarAccordion,
  SidebarItemContent,
  SidebarLink,
} from './DesktopSidebarNav';
import type { SidebarGroup } from './DesktopSidebar.types';
import { useSidebarCollapsed } from './sidebarCollapse';
import { SidebarTooltip } from './SidebarTooltip';

type DesktopSidebarOrganizationProps = {
  groups: SidebarGroup[];
  groupsLoading: boolean;
  accordionOpen: boolean;
  otdelsOpen: boolean;
  selectedGroupId: string | null;
  selectedGroupName: string;
  onNavigate: (to: string) => void;
  onAccordionToggle: () => void;
  onOtdelsOpenChange: (open: boolean) => void;
};

export function DesktopSidebarOrganization({
  groups,
  groupsLoading,
  accordionOpen,
  otdelsOpen,
  selectedGroupId,
  selectedGroupName,
  onNavigate,
  onAccordionToggle,
  onOtdelsOpenChange,
}: DesktopSidebarOrganizationProps) {
  const collapsed = useSidebarCollapsed();

  return (
    <SidebarAccordion
      title="КОМПАНИЯ"
      open={accordionOpen}
      onToggle={onAccordionToggle}
      divider
    >
      <SidebarLink item={organizationItems[0]} />

      <DropdownMenu open={otdelsOpen} onOpenChange={onOtdelsOpenChange}>
        <DropdownMenuTrigger asChild>
          <SidebarTooltip label={selectedGroupName}>
            <button
              type="button"
              className={getNavItemClass(
                Boolean(selectedGroupId),
                false,
                collapsed
              )}
              style={selectedGroupId ? activeNavItemStyle : undefined}
            >
              <SidebarItemContent
                Icon={OrganizationDepartmentsIcon}
                label={selectedGroupName}
                active={Boolean(selectedGroupId)}
              />
            </button>
          </SidebarTooltip>
        </DropdownMenuTrigger>
        {/* Свёрнутый сайдбар узкий — список отделов открываем вбок. */}
        <DropdownMenuContent
          side={collapsed ? 'right' : 'bottom'}
          align="start"
          className={dropdownContentClass}
        >
          {groupsLoading ? (
            <DropdownMenuItem disabled>Загрузка...</DropdownMenuItem>
          ) : (
            groups
              .slice()
              .sort((a, b) => a.Name.localeCompare(b.Name, 'ru'))
              .map((group) => (
                <DropdownMenuItem
                  key={group.ID}
                  className={
                    String(group.ID) === selectedGroupId
                      ? 'cursor-pointer text-[calc(13px*var(--nav-scale,1))] bg-[#102653] text-white focus:bg-[#102653] focus:text-white'
                      : 'cursor-pointer text-[calc(13px*var(--nav-scale,1))] focus:bg-[#F6F7FA] focus:text-[#17244A]'
                  }
                  onSelect={() => onNavigate(`/groups/${group.ID}`)}
                >
                  {group.Name}
                </DropdownMenuItem>
              ))
          )}
        </DropdownMenuContent>
      </DropdownMenu>

      <SidebarLink item={organizationItems[1]} />
      <SidebarLink item={organizationItems[2]} />
      <SidebarLink item={organizationItems[3]} />
    </SidebarAccordion>
  );
}
